








































import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import { ICustomStylingClass } from '../types/custom.t';

@Component
export default class CustomInput extends Vue {
  @Model('update', { type: String })
  value: any;

  @Prop()
  containerClass?: ICustomStylingClass[];

  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop()
  disabled?: boolean;

  @Prop()
  id?: string;

  @Prop()
  label?: string;

  @Prop()
  labelClass?: ICustomStylingClass[];

  @Prop()
  maxlength?: number;

  @Prop()
  max?: number;

  @Prop()
  min?: number;

  @Prop()
  multiple?: boolean;

  @Prop()
  name?: string;

  @Prop()
  pattern?: string;

  @Prop()
  placeholder?: string;

  @Prop()
  readonly?: boolean;

  @Prop()
  required?: boolean;

  @Prop({ default: false })
  requiredMask!: boolean;

  @Prop()
  step?: number;

  @Prop()
  type!: string;

  handleInput(ev: any): void {
    this.$emit('update', ev.target.value);
    this.$emit('input', ev);
  }
}
